import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient, updateClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { UserTypes } from "../../enum/UserTypes";
import { useNavigate } from "react-router-dom";
import { removeEmployee, updateEmployee } from "../../service/employeeService";
import { addForm, updateForm } from "../../service/formService";

export default function FormsTable(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = 'form';

  const baseFilter = {
    'full_name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'id_number': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'active': { value: null, matchMode: FilterMatchMode.CONTAINS },
  }

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    removeClient(selectedRecord.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRecord(null);
    if (props.setForm) {
      console.log("Set Form ");
      props.setForm(null);
    }
    navigate('/form-builder');
  }

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    if (props.setForm) {
      console.log("Set Form ");
      props.setForm(value);
    }
    setSelectedRecord(value);
    viewSelected(row);

  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRecord(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await removeEmployee(selectedRecord.id);
    props.setGlobalLoader(false);
    toast.current.show({ severity: 'success', summary: 'Employee Deleted Successfully', life: 3000 });
  }


  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }


  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await updateEmployee({ "active": status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Employee Activated Successfully' : 'Employee Deactivated Successfully', life: 3000 });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  }

  const viewSelected = (row: any) => {
    if (props.setForm) {
      console.log("Set Form ");
      props.setForm(selectedRecord);
    }
    navigate('/form-builder');
  }

  const previewSelected = (row: any) => {
    if (props.setForm) {
      props.setForm(selectedRecord);
    }
    navigate('/form-view');
  }

  const duplicate = (row: any) => {
    props.setGlobalLoader(true);
    addForm({
      form: selectedRecord.form,
      config: selectedRecord.config,
      name: `${selectedRecord.name} Duplicate`,
      description: selectedRecord.description,
    }).then((r: any) => {
      toast.current.show({ severity: 'success', summary: 'Form Created Successfully', life: 3000 });
      props.setGlobalLoader(false);
      setReload(!reload);
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'Form Created Failed', life: 3000 });
      props.setGlobalLoader(false);
    })
  }

  const contextItems = () => {
    let objArray = [
      { label: 'View / Edit', icon: 'pi pi-fw pi-pencil', command: viewSelected },
      { label: 'Duplicate', icon: 'pi pi-fw pi-copy', command: duplicate },
      { label: 'Preview', icon: 'pi pi-fw pi-eye', command: previewSelected },
    ];
    if (selectedRecord?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Forms
        </Typography>

      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url={url} columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}